import type { ReactNode } from 'react';
import './components.css';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="empty-state">
      {icon && (
        <div className="empty-state__icon" aria-hidden="true">
          {icon}
        </div>
      )}
      <div className="empty-state__title">{title}</div>
      {description && <p>{description}</p>}
      {action}
    </div>
  );
}
